import { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'
import { inject, observer } from 'mobx-react/index'

import Layout from '../components/Layout'
import Footer from '../components/Footer'
import BlogHeader from '../components/Blog/BlogHeader'
import WysiwygContent from '../components/WysiwygContent'
import SocialsAndTags from '../components/SocialsAndTags'
import PostGrid from '../components/PostGrid'

import { withTranslation } from '../i18n'

import {
  BlogContent, SubTitle
} from '../styles/blogStyles'

import {
  AuthorInfo, Biography
} from '../styles/authorStyles'

import { getEntityByID } from '../api/routes'

@inject('store')
@observer
class Author extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    store: PropTypes.instanceOf(Object).isRequired,
    router: PropTypes.instanceOf(Object).isRequired,
    author: PropTypes.instanceOf(Object).isRequired,
    i18n: PropTypes.instanceOf(Object).isRequired
  }

  static async getInitialProps({ req, query }) {
    const currentLanguage = req ? req.language : query.lng
    const author = await getEntityByID(query.id, 'journal_authors', currentLanguage)
    return {
      namespacesRequired: ['magazine', 'common', 'auth', 'reset-password', 'contacts', 'about', 'artists'],
      author
    }
  }

  constructor(props) {
    super(props)
    this.state = { author: props.author }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.i18n.language !== prevProps.i18n.language) {
      const { router: { query }, i18n: { language } } = this.props
      const author = await getEntityByID(query.id, 'journal_authors', language)
      this.changeAuthor(author)
    }
  }

  changeAuthor(author) {
    this.setState({ author })
  }

  render() {
    const { t, store: { posts } } = this.props
    const { author } = this.state
    const links = author.links || {}
    const { other: others, ...socials } = links

    return (
      <Layout meta={{ title: author.name, image: author.avatar, description: author.caption }}>
        <BlogHeader />

        <BlogContent className="content">
          <AuthorInfo>
            <img src={author.avatar} alt={author.name} className="avatar" />
            <div className="authorInfo">
              <h1>{author.name}</h1>
              <p>{author.caption}</p>
              <div className="links">
                <SocialsAndTags others={others} socials={socials} />
              </div>
            </div>
          </AuthorInfo>
          {!!author.biography && (
          <Biography>
            <h2>{t('biography')}</h2>
            <WysiwygContent content={author.biography} className="biographyText" />
          </Biography>
          )}
          {!!posts.length && (<SubTitle showBorder={!!author.biography}>{t('latest-publications')}</SubTitle>)}
          <PostGrid author={author.id} />
        </BlogContent>
        <Footer />
      </Layout>
    )
  }
}

const WithRouter = withRouter(Author)
export default withTranslation(
  ['magazine', 'common', 'auth', 'reset-password', 'contacts', 'about', 'artists'])(WithRouter)
